import auth from './auth.js'
export default {auth}


// WEBPACK FOOTER //
// ./src/directives/index.js